export default {
	message:(resource,error)=>{
		if (!error || !error.response || !error.response.status) return 'oops, there was a problem with '+resource;
		if (String(error.response.status) === '400') return resource+' bad request';
		if (String(error.response.status) === '404') return resource+' not found';
		if (String(error.response.status) === '409') return resource+' resource conflict';
		if (String(error.response.status).substr(0,1) === '4') return resource+' request error';
		if (String(error.response.status).substr(0,1) === '5') return 'oops, there was a problem with '+resource;
		return 'oops, there was a problem with '+resource;
	}
};


// WEBPACK FOOTER //
// ./src/api/api-error.js